
import React, { Component } from 'react';
import { injectIntl, defineMessages } from 'react-intl'
import Select from 'react-select';

const messages = defineMessages({
    "companies": {
        id: "listing.customers.companies",
        defaultMessage: "Companies",
    },
    "people": {
        id: "listing.customers.persons",
        defaultMessage: "People",
    },
})

class ContactTypeSelect extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            selectedOption: this.props.value || '',
            options: [],
            multi: this.props.multi || false,
        }
        this.state.options = [
            {
                value: 'organizations',
                label: this.props.intl.formatMessage(messages["companies"])
            },
            {
                value: 'persons',
                label: this.props.intl.formatMessage(messages["people"])
            }

        ]
        this.onChangeSelect = this.onChangeSelect.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.value !== this.state.selectedOption) {
            this.setState({
                selectedOption: nextProps.value || []
            })
        }
    }

    onChangeSelect(selectedOption) {
        this.setState({
            selectedOption: selectedOption
        }, () => {
            if(selectedOption){
                if (this.state.multi === true) {
                    this.props.onChange(selectedOption.map(option => { return option.value }), selectedOption.map(option => { return option.label }).join(','))
                } else {
                    this.props.onChange(selectedOption.value, selectedOption.label)
                }
            }else{
                this.props.onChange("","")
            }
        });
    }

    render() {
        return (
            <div className="panel panel-default card">
                <Select
                    name="contact-type-select"
                    multi={this.state.multi}
                    value={this.state.selectedOption}
                    onChange={this.onChangeSelect}
                    id="contact-type-select"
                    options={this.state.options}
                />
            </div>

        );
    }
}
export default injectIntl(ContactTypeSelect);



// WEBPACK FOOTER //
// ./src/common/contact/contactTypeSelect.component.jsx